import { render, staticRenderFns } from "./DashboardGeral.vue?vue&type=template&id=14d1526e&scoped=true&"
import script from "./DashboardGeral.vue?vue&type=script&lang=js&"
export * from "./DashboardGeral.vue?vue&type=script&lang=js&"
import style0 from "./DashboardGeral.vue?vue&type=style&index=0&id=14d1526e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14d1526e",
  null
  
)

export default component.exports